(function () {
  angular.module('7Terminal.Core').constant('LocalData', {});
})();
